import {ref, Ref} from "vue"

const locale: Ref<string | null> = ref(null)

export default locale